var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCommunicationsDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.374 15.342 8.532 5.4V9.726zM2.598 9.726v11.016l8.532-5.4zM26.322 6.522H4.182c-.792 0-1.422.594-1.53 1.35l12.6 8.298 12.6-8.298c-.126-.756-.738-1.35-1.53-1.35zM17.916 16.296l-2.232 1.476a.755.755 0 0 1-.432.126.755.755 0 0 1-.432-.126l-2.232-1.476-9.918 6.282c.126.756.738 1.332 1.53 1.332h22.14c.792 0 1.404-.576 1.53-1.332l-9.954-6.282z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCommunicationsDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-communications-default.8e418d08518d7fa803baa300a2fcaf87.svg";